import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TCarbonProjectData } from "../../types";
import { Location } from "./components/Location";
import { ProjectDescription } from "./components/ProjectDescription";
import { Breadcrumb } from "../../components/BreadCrumb";
import ProjectTabs from "./components/ProjectTabs";
import { RecommendedProjects } from "./components/RecommendedProjects";
import { api } from "../../api";
import ProjectTrackingCard from "./components/ProjectTrackingCard";
import ProjectDocumentationListCard from "./components/ProjectDocumentationListCard";
import CreditInformationCard from "./components/CreditInformationCard";
import TitleSection from "./components/TitleSection";
import { ProjectInformation } from "./components/ProjectInformation";

const ProjectPage = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const [projectData, setProjectData] = useState<TCarbonProjectData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    const fetchProjectData = async (id: string) => {
      try {
        const response = await api.get<{ carbon_project: TCarbonProjectData }>(
          `/projects/carbon/${id}`,
        );
        const data = response.data.carbon_project;
        if (isMounted) {
          setProjectData(data);
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          navigate("/");
        }
      }
    };

    fetchProjectData(id);

    return () => {
      isMounted = false; // Cleanup to avoid setting state on unmounted component
    };
  }, [id, navigate]);

  const projectDetailPageTabs = (projectData: TCarbonProjectData | null) => [
    {
      title: "Overview",
      value: "Overview",
      content: (
        <div>
          <section className="grid grid-cols-2 gap-6">
            <div className="flex flex-col gap-6">
              <ProjectDescription description={projectData?.properties?.description} />
            </div>
            <div>
              <Location
                lat={projectData?.geometry?.coordinates[1] ?? 0}
                lng={projectData?.geometry?.coordinates[0] ?? 0}
              />
            </div>
            <div className="col-span-2">
              <ProjectTrackingCard />
            </div>
            <div>
              <ProjectDocumentationListCard />
            </div>
            <div>
              <CreditInformationCard />
            </div>
            <div className="col-span-2">
              <RecommendedProjects />
            </div>
          </section>
        </div>
      ),
    },
    /*    {
          title: "People",
          value: "People",
          content: <PeopleTab />,
        },
        {
          title: "Planet",
          value: "Planet",
          // content: (
          //   <section className="grid grid-cols-1 gap-6">
          //     <LULCMap />
          //   </section>
          // ),
          content: <PlanetTab />,
        },
        {
          title: "Technical",
          value: "Technical",
          content: <TechnicalTab />,
        },
        {
          title: "Risks",
          value: "Risks",
          content: <RisksTab />,
        },
        {
          title: "Finance",
          value: "Finance",
          content: <FinanceTab />,
        },*/
  ];

  const render = (projectData: TCarbonProjectData) => {
    return (
      <div className="mb-6 flex w-full flex-col gap-4 px-6">
        <Breadcrumb />
        <TitleSection
          id={projectData.properties?.id}
          name={projectData.properties?.name}
          status={projectData.properties?.status}
          isSaved={projectData.properties?.isSaved}
        />
        <section className="relative flex flex-row items-center gap-10">
          <ProjectInformation projectData={projectData} projectType="current" />
        </section>

        <ProjectTabs projectDetailPageTabs={projectDetailPageTabs(projectData)} />
      </div>
    );
  };

  return !loading && projectData && projectData.properties ? (
    render(projectData)
  ) : (
    <div>Loading...</div>
  );
};

export default ProjectPage;
